import classNames from "classnames";
import { TaskInProgressIcon } from "@icons/taskStatuses";
import styles from "./TaskInProgressSpinnerIcon.module.scss";

interface TaskInProgressSpinnerIconProps {
    className?: string;
}

/**
 * The In progress task icon with its arc slowly sweeping around: the
 * "a person is working on it" icon for an animated `StatusPill`. Like
 * `KickWorkingIcon`, it moves only inside a running pill.
 *
 * @example <StatusPill icon={<TaskInProgressSpinnerIcon />} label="In progress" isAnimated />
 */
export const TaskInProgressSpinnerIcon = ({
    className,
}: Readonly<TaskInProgressSpinnerIconProps>) => (
    <span className={classNames(styles.spinnerBox, className)} aria-hidden>
        <TaskInProgressIcon className={styles.spinner} />
    </span>
);
